export default __webpack_public_path__ + "static/7_vetrex-1c3c9d98c26601c47e4dd9037ff36ce9.png";